<div class="image-container">
  <img
    src="{{ previewURL || avatar }}"
    alt="{{ 'avatar.company.logo_alt' | translate }}"
  />
</div>
<ng-container *ngIf="isInfoAvatar()">
  <div class="content-container info">
    <div class="name">{{ name }}</div>
    <div class="area">{{ area }} {{ subarea ? '| ' + subarea : '' }}</div>
    <div class="address">{{ address }}</div>
  </div>
</ng-container>
<ng-container *ngIf="!isInfoAvatar()">
  <div class="button-container">
    <div class="button-texts">
      <div class="upload-text">
        {{ 'avatar.company.upload_new' | translate }}
      </div>
      <div class="info-text">
        {{ 'avatar.company.image_format' | translate }}
      </div>
      <div
        [ngStyle]="{
          color: isAvatarTooBig ? 'red' : '',
        }"
        class="info-text"
      >
        {{
          isAvatarTooBig
            ? ('avatar.company.size_exceeded' | translate)
            : ('avatar.company.max_size' | translate)
        }}
      </div>
      @if (!isFileTypeValid) {
        <div class="info-text" [ngStyle]="{ color: 'red' }">
          {{ 'avatar.company.invalid_file' | translate }}
        </div>
      }
      <div class="choose">
        <input
          type="file"
          (change)="selectFile($event)"
          class="select-profile-picture"
          accept="image/png, image/jpeg"
        />
        <div class="message">
          <img class="icon-upload" src="../assets/svg/icons8-upload.svg" />
          <span>{{ 'avatar.company.choose_picture' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
